/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  errorMessagesInRedux: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  fromDateValue: '',
  toDateValue: '',
  rebateProgramName: '',
  searchResult: [],
  manufacturerList: [],
  isLoading: false,
  manufacturerSelected: '',
  manufacturerSelectedName: '',
  allRebateProgram: false,
  isAllManufacturersSelected: true,
  scrollDownManufacturers: true,
  rebateProgrameName: '',
  selectedReport: 'Detail',
  searchScreenVar: {
    rebateProgramValue: '',
    selectedPlanType: '',
    fromDateValue: '',
    toDateValue: '',
    rebateProgramName: '',
    allRebateProgram: false,
    isAllManufacturersSelected: true,
    scrollDownManufacturers: true,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_UNALLOACTED_BALANCE:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_CASH_RECEIPT_SUMMARY:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ADJUSTMENT_REASON_CODE:
      return { ...state, isLoading: action.isLoading };
    // Manufacturer Grid
    case ActionTypes.GET_MANUFACTURER_LIST_CASH_RECEIPT_SUMMARY:
      return { ...state, manufacturerList: action.manufacturerList };
    case ActionTypes.SET_SELECTED_REPORT_DRUG:
      return { ...state, selectedReport: action.payload };
    case ActionTypes.REFRESH_CASH_RECEIPT_SUMMARY:
      return { ...state, searchScreenVar: action.payload };
    // For Result grid
    case ActionTypes.GET_RESULT_GRID_CASH_RECEIPT_SUMMARY:
      return { ...state, searchResult: action.searchResult };
    case ActionTypes.HANDLE_ERROR_MESSAGE_CRS:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    default:
      return state;
  }
};

export default reducer;
